const capitalizeNameSegment = (segment = "") => {
  const lowered = segment.toLowerCase();
  return lowered ? `${lowered[0].toUpperCase()}${lowered.slice(1)}` : "";
};


export const formatPersonName = (value = "") => value
  .trim()
  .split(/\s+/)
  .filter(Boolean)
  .map((word) => word
    .split(/([-'])/)
    .map((segment) => (segment === "-" || segment === "'" ? segment : capitalizeNameSegment(segment)))
    .join(""))
  .join(" ");


export const formatDisplayName = (firstName = "", surname = "") => [formatPersonName(firstName), formatPersonName(surname)]
  .filter(Boolean)
  .join(" ")
  .trim();


export const formatDisplayNameString = (value = "") => formatPersonName(value);